export enum SourceRegionIdTurnKey {
  USA = 50,
  China = 51,
  Europe = 49,
}
